import Vue from 'vue'
import {
  ActionSheet,
  Area,
  Button,
  Checkbox,
  Dialog,
  Field,
  Icon,
  NumberKeyboard,
  PasswordInput,
  Popup,
  Picker,
  DatetimePicker,
  Toast
} from 'vant'
import 'vant/lib/action-sheet/style'
import 'vant/lib/area/style'
import 'vant/lib/button/style'
import 'vant/lib/checkbox/style'
import 'vant/lib/dialog/style'
import 'vant/lib/field/style'
import 'vant/lib/icon/style'
import 'vant/lib/number-keyboard/style'
import 'vant/lib/password-input/style'
import 'vant/lib/popup/style'
import 'vant/lib/picker/style'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/toast/style'
import App from './App.vue'
import router from './router'
import './styles/global.scss'

Vue.use(ActionSheet)
Vue.use(Area)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Icon)
Vue.use(NumberKeyboard)
Vue.use(PasswordInput)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Toast)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
